import { render, staticRenderFns } from "./x-draggable-dialog.vue?vue&type=template&id=f896a3f4&scoped=true"
import script from "./x-draggable-dialog.vue?vue&type=script&lang=js"
export * from "./x-draggable-dialog.vue?vue&type=script&lang=js"
import style0 from "./x-draggable-dialog.vue?vue&type=style&index=0&id=f896a3f4&prod&lang=scss"
import style1 from "./x-draggable-dialog.vue?vue&type=style&index=1&id=f896a3f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f896a3f4",
  null
  
)

export default component.exports